"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../theme"));
const useStyles = (0, _styles.makeStyles)({
  root: {
    '& .MuiTableRow-root': {
      verticalAlign: 'initial'
    },
    '& .MuiPaper-root': {
      [_theme.default.breakpoints.down('xs')]: {
        width: 'calc(100% - 32px)',
        minWidth: 'calc(100% - 32px)',
        maxWidth: 'calc(100% - 32px)'
      }
    },
    '& .guestName': {
      paddingLeft: 0,
      paddingRight: 0
    },
    '& .guestType': {
      paddingLeft: '5px',
      paddingRight: '20px',
      width: '168px',
      [_theme.default.breakpoints.down('440')]: {
        width: '118px'
      }
    },
    '& .unaccompaniedMinorError': {
      display: 'block',
      paddingTop: '8px',
      color: _theme.default.palette.error.main
    },
    '& .guestSelector': {
      paddingLeft: '15px'
    },
    '& .MuiList-padding': {
      padding: '0px !important',
      [_theme.default.breakpoints.down('539')]: {
        width: '400px'
      },
      [_theme.default.breakpoints.down('439')]: {
        width: '100%'
      },
      [_theme.default.breakpoints.up('540')]: {
        width: '500px'
      }
    },
    '& .onLapOptionSelectorContainer': {
      display: 'grid'
    },
    '& .onLapOptionSelector': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& .MuiIconButton-root:first-child': {
        padding: '0',
        marginRight: '5px'
      },
      '& .MuiIconButton-root:last-child': {
        padding: '0',
        marginLeft: '5px'
      },
      '& .infantTypeLabel': {
        width: '110px',
        [_theme.default.breakpoints.down('440')]: {
          width: '70px'
        }
      }
    },
    '& .guestButtonWrapper': {
      padding: '20px !important',
      '& button': {
        width: 'fit-content'
      }
    },
    '& .MuiIconButton-root': {
      color: _theme.default.palette.primary.light,
      '&.Mui-disabled': {
        color: _theme.default.palette.grayScale.main
      }
    },
    '& .doneButton': {
      marginLeft: 'unset !important'
    },
    '& .cancelButton': {
      marginLeft: 'auto'
    },
    '& .MuiButtonBase-root:not(.MuiCheckbox-root, .MuiIconButton-root, .cancelButton, .doneButton)': {
      cursor: 'default'
    },
    '& .MuiTable-root': {
      padding: '14px !important',
      marginBottom: '20px',
      marginTop: '10px'
    }
  },
  menuBody: {
    padding: '0px !important'
  },
  label: {
    fontSize: _theme.default.typography.pxToRem(14),
    margin: '0 0 8px 0'
  }
});
var _default = exports.default = useStyles;